'use client';

import { useCallback } from 'react';
import { useNotification } from '@nusrif/contexts';
import { NotificationType } from '@nusrif/types';

export const useNotificationHelpers = () => {
  const { showNotification } = useNotification();

  const showSuccess = useCallback((title: string, message?: string) => {
    showNotification({
      type: 'success',
      title,
      message,
    });
  }, [showNotification]);

  const showError = useCallback((title: string, message?: string) => {
    showNotification({
      type: 'error',
      title,
      message,
    });
  }, [showNotification]);

  const showWarning = useCallback((title: string, message?: string) => {
    showNotification({
      type: 'warning',
      title,
      message,
    });
  }, [showNotification]);

  const showInfo = useCallback((title: string, message?: string) => {
    showNotification({
      type: 'info',
      title,
      message,
    });
  }, [showNotification]);

  const showCustom = useCallback((
    type: NotificationType,
    title: string,
    message?: string,
    duration?: number,
    action?: { label: string; onClick: () => void }
  ) => {
    showNotification({
      type,
      title,
      message,
      duration,
      action,
    });
  }, [showNotification]);

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showCustom,
  };
}; 